import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color", "size"],
    _excluded2 = ["withBackDrop", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var colorOptions = ['primary', 'secondary', 'gray'];
export var sizeOptions = ['xs', 'sm', 'md', 'lg'];

var SpinnerVariantElement = /*#__PURE__*/_styled.svg.withConfig({
  displayName: "spinnercontants__SpinnerVariantElement",
  componentId: "sc-zg3v0r-0"
})(["", " ", ""], function (_ref) {
  var color = _ref.color;

  switch (color) {
    case 'primary':
      return {
        "fill": "#8e69ce"
      };

    case 'secondary':
      return {
        "fill": "#d0e124"
      };

    case 'gray':
      return {
        "fill": "#4B5563"
      };

    case 'success':
      return {
        "fill": "#00542d"
      };

    case 'warning':
      return {
        "fill": "#9e5400"
      };

    case 'error':
      return {
        "fill": "#910018"
      };

    case 'restworld':
      return {
        "fill": "#482485"
      };

    case 'reversed':
      return {
        "fill": "#ffffff"
      };

    case 'neutral':
      return {
        "fill": "#1c1c33"
      };

    case 'tertiary':
      return {
        "fill": "#1c1c33"
      };

    default:
      return {
        "fill": "#8e69ce"
      };
  }
}, function (_ref2) {
  var size = _ref2.size;

  switch (size) {
    case 'xs':
      return {
        "height": "1rem",
        "width": "1rem"
      };

    case 'sm':
      return {
        "height": "1.5rem",
        "width": "1.5rem"
      };

    case 'md':
      return {
        "height": "2rem",
        "width": "2rem"
      };

    case 'lg':
      return {
        "height": "2.5rem",
        "width": "2.5rem"
      };

    default:
      return {
        "height": "2rem",
        "width": "2rem"
      };
  }
});

var _StyledSpinnerVariantElement = /*#__PURE__*/_styled(SpinnerVariantElement).withConfig({
  displayName: "spinnercontants___StyledSpinnerVariantElement",
  componentId: "sc-zg3v0r-1"
})({
  "display": "inline",
  "@keyframes spin": {
    "to": {
      "transform": "rotate(360deg)"
    }
  },
  "animation": "spin 1s linear infinite",
  "--tw-text-opacity": "1",
  "color": "rgb(229 231 235 / var(--tw-text-opacity))",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  }
});

var SpinnerElement = function SpinnerElement(_ref3) {
  var color = _ref3.color,
      size = _ref3.size,
      rest = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_jsxs(_StyledSpinnerVariantElement, _objectSpread(_objectSpread({
    "aria-hidden": "true",
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: color,
    size: size
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      fill: "currentFill"
    })]
  }));
};

export var Spinner = function Spinner(_ref4) {
  var withBackDrop = _ref4.withBackDrop,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded2);

  var spinnerEl = /*#__PURE__*/_jsx(SpinnerElement, _objectSpread({}, rest));

  var el = /*#__PURE__*/_jsxs(_Fragment, {
    children: [spinnerEl, children]
  });

  return /*#__PURE__*/_jsxs(_StyledDiv, _objectSpread(_objectSpread({
    role: "status"
  }, rest), {}, {
    children: [withBackDrop ? /*#__PURE__*/_jsx(SpinnerBackDropWrapper, {
      children: el
    }) : el, /*#__PURE__*/_jsx("span", {
      className: "sr-only"
    })]
  }));
};
export var SpinnerBackDropWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "spinnercontants__SpinnerBackDropWrapper",
  componentId: "sc-zg3v0r-2"
})(["", ""], {
  "position": "absolute",
  "top": "0px",
  "zIndex": "10",
  "display": "flex",
  "height": "100vh",
  "width": "99vw",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "backgroundColor": "rgb(255 255 255 / 0.3)",
  "--tw-backdrop-blur": "blur(4px)",
  "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)",
  "@media (min-width: 1024px)": {
    "flexDirection": "row"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "spinnercontants___StyledDiv",
  componentId: "sc-zg3v0r-3"
})({
  "position": "relative"
});